import { Provider } from '@angular/core';
import { Routes } from '@angular/router';
import { SvcDialogResolver } from '@solvace/component/svc-dialogs';
import { DialogAlertType, SVC_MODAL_ALERT_OVERRIDE } from '@solvace/feature/modals/svc-modal-alert';

import { ALERT_RECORD_DIALOG_CONFIG, ALERT_RECORD_MODAL_OVERRIDE, AlertRecordModalComponent } from './alert-record-modal.component';

/** Makes `AlertService.openAlert` open the redesigned alert modal in the providing app. */
export function provideAlertRecordModal(): Provider[] {
  return [{ provide: SVC_MODAL_ALERT_OVERRIDE, useValue: ALERT_RECORD_MODAL_OVERRIDE }];
}

/** Lazy route that opens the redesigned modal in add mode, for hosts that link to "new alert". */
export const ALERT_RECORD_NEW_ROUTES: Routes = [
  {
    path: '',
    component: AlertRecordModalComponent,
    resolve: { dialogRef: SvcDialogResolver },
    data: {
      ...ALERT_RECORD_DIALOG_CONFIG,
      resolveDialog: () => ({ mode: DialogAlertType.add }),
    },
  },
];
